<template>

    <v-container fluid grid-list-md>
        <v-layout row wrap>
      <v-flex xm12 class="display-1 font-weight-light text-sm-left">
          ELECTIVES
      </v-flex>

      <v-flex xs12>
        <p>The FLLI Elective Curriculum provides a wide array of elective course offerings to equip you to become a fully integrated leader who can manage yourself, your broad network of colleagues, your team of managers, and your resources.</p>
        <p>Elective courses provide specialized focus on topics needed to achieve success in your career as an FAA leader. Offerings include Instructor-led Training (ILT), Web-based Training (WBT), and Blackboard (Bb) courses, giving you options to fit learning into your busy schedule.</p>
      </v-flex>

      <v-flex xs12>

        <v-data-table ref="expandableTable"
            :headers="headers"
            :items="filteredCourses"
            hide-default-footer item-key="id" 
            class="elevation-1 clickable"
            :items-per-page=200
            @click:row="openCourse"
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ props.header.text }}
                  </span>
                </template>
                <span>
                  {{ props.header.text }}
                </span>
              </v-tooltip>
            </template>
            <template v-slot:items="props">
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.title }}</td>
              <td class="text-xs-center">{{ props.item.length }}</td>
              <td class="text-xs-center">{{ props.item.format }}</td>
            </template>
          </v-data-table>

		  </v-flex>


        </v-layout>
    </v-container>
</template>


<script>
export default{
      props: {
        slc: {
          type: String,
          default:''
        },
        curr: {
          type: String,
          default:''
        }
      },
  data () {
     return {
      slcList: [        
        {id: "FOM", text: "Focusing on Mission"},
        {id: "DO", text: "Developing Others"},
        {id: "VDAI", text: "Valuing Diversity and Inclusion"},
        {id: "EI", text: "Encouraging Innovation"},
        {id: "CE", text: "Communicating Effectively"},
        {id: "WC", text: "Working Collaboratively"},
        {id: "LWI", text: "Leading with Influence"},
        {id: "DA", text: "Demonstrating Accountability"},
        {id: "", text: "any"}
      ],
      formatList: [
        {id: "Bb", text: "Blackboard"},
        {id: "ILT", text: "Instructor-led"},
        {id: "WBT", text: "WBT"},
        {id: "", text: "any"}
      ],
      currList: [
        {id: "NMC", text: "NEW MANAGER"},
        {id: "MMC", text: "MIDDLE MANAGER"},
        {id: "SMEC", text: "SENIOR MANAGER/EXECUTIVE"},
        {id: "EC", text: "FLLI ELECTIVE"},
        {id: "FFSC", text: "FLLI FEE-FOR-SERVICE"},
        {id: "OEFFSC", text: "ORGANIZATIONAL EFFECTIVENESS FEE-FOR-SERVICE"},
        {id: "", text: "any"}
      ],
      currFilter: '',
      updating: false,
      allCourses: [],
      filteredCourses: [],
         headers: [
         {
            text: 'COURSE #',
            align: 'left',
            sortable: false,
            value: 'id'
          },
          { text: 'COURSE NAME', value: 'title' },
          { text: 'LENGTH', value: 'length' },
          { text: 'FORMAT', value: 'format' }
        ]
     }
  },
  methods: {
    loadAndParseJSON () {
        this.allCourses = require('../json/course_list_data_flat.json')
        this.updateData()
    },
      getImgUrl(type) {
            var images = require.context('../assets/', false, /\.png$/)
            return images('./coursetype-' + type + '.png')
      },
      openCourse(e) {
        this.$router.push({ path: '/course/' + e.id });
      },
    async updateData() {
      this.updating = true
      var items = this.allCourses.courses

        var p4 = items.filter(
          ({ curriculumId }) =>
            curriculumId.includes('EC') 
        );
        items = p4

      //FINE RICHIESTA
      this.filteredCourses = items
      this.updating = false
    }      
  },
  mounted: function () {
    this.loadAndParseJSON()
  },
}
</script>

<style>
.coursetypeicon {
  display: inline-block;
  max-width: 25
px; /* only this one important */
  margin-bottom: 1rem;
  line-height: 0; 
}
.clickable {
  cursor: pointer;
}
.v-data-table td {
    font-size: 14px;
    height: 35px;
}
.v-data-table-header-mobile__wrapper {
    display: none;
}
.v-data-table__mobile-row__header {
    display: none;
}
.v-data-table__mobile-row__cell {
    text-align: left;
}
</style>
